<template>
    <mt-search
        ref="search"
        class="entity-autocomplete"
        :disabled="disabled"
        :errorMessage="errorMessage"
        :label="label"
        :limit="1000"
        :searchTypes="entityTypes"
        :showViewAll="false"
        @navigating="autocomplete"
    >
        <template #static-option-append="props">
            <slot v-bind="props" name="static-option-append" />
        </template>
    </mt-search>
</template>
<script>
import actions from '@/store/actions.js'
import MtSearch from './mt-search.vue'
export default {
    components: {
        MtSearch,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        entityTypes: {
            type: Array,
            default() {
                return null
            },
        },
        errorMessage: {
            type: [String, Array],
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
    },
    methods: {
        autocomplete(event, entity) {
            event.stopPropagation()
            event.preventDefault()

            this.$emit('autocomplete', entity)
            this.$store.dispatch(actions.closePopover, null)
        },
        blur() {
            this.$refs.search.blur()
        },
        clear() {
            this.$refs.search.clear()
        },
        focus() {
            this.$refs.search.focus()
        },
    },
}
</script>
<style>
.entity-autocomplete {
    .search-input-absolute {
        min-width: 100%;
        max-width: 100%;
    }

    .search-result button {
        display: none;
    }
}
</style>
